import { useLocation, useNavigate } from 'react-router-dom';

/**
 * The Finance areas. `/finance` lands on the Cockpit (the overview), so the sidebar entry and any
 * signal linking to Finance arrive at the work list rather than in the middle of the invoice table.
 */
const areas = [
  { key: 'cockpit', label: 'Cockpit', route: '/finance' },
  { key: 'outgoing', label: 'Ausgangsrechnungen', route: '/finance/abrechnung' },
  { key: 'incoming', label: 'Eingangsrechnungen', route: '/finance/eingangsrechnungen' },
  { key: 'ankauf', label: 'Ankauf', route: '/finance/ankauf' },
  { key: 'opos', label: 'Offene Posten', route: '/finance/offene-posten' },
  { key: 'mahnwesen', label: 'Mahnwesen', route: '/finance/mahnwesen' },
  { key: 'accounting', label: 'Buchhaltung', route: '/finance/buchhaltung' },
  { key: 'closing', label: 'Abschluss', route: '/finance/abschluss' },
] as const;

function activeArea(pathname: string): string {
  if (pathname.startsWith('/finance/abrechnung') || pathname.startsWith('/finance/rechnungen')) return 'outgoing';
  if (pathname.startsWith('/finance/eingangsrechnungen')) return 'incoming';
  if (pathname.startsWith('/finance/ankauf')) return 'ankauf';
  if (pathname.startsWith('/finance/offene-posten')) return 'opos';
  if (pathname.startsWith('/finance/mahnwesen')) return 'mahnwesen';
  if (pathname.startsWith('/finance/buchhaltung')) return 'accounting';
  if (pathname.startsWith('/finance/abschluss')) return 'closing';
  return 'cockpit';
}

/** Sub-navigation between the Finance areas. Active area derived from the route. */
export function FinanceNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const active = activeArea(location.pathname);
  return (
    <nav className="finance-nav" aria-label="Finance-Bereiche">
      {areas.map((area) => (
        <button
          key={area.key}
          type="button"
          className={area.key === active ? 'is-active' : ''}
          onClick={() => navigate(area.route)}
        >
          {area.label}
        </button>
      ))}
    </nav>
  );
}
